<template>
  <div class="overflow-menu-container">
    <menu-button
        @click="toggleMenu"
        :menu-button-color="menuButtonColor"
        :aria-label="ariaLabel"
        :aria-haspopup="true"
        :aria-expanded="showMenu"
        :aria-controls="showMenu ? 'overflow-menu' : undefined" />
    <ul @click.stop id="overflow-menu" class="overflow-menu" v-if="showMenu" v-click-outside="closeMenu"
        aria-labelledby="overflow-menu-button-container" role="menu">
      <slot name="menuItems"/>
    </ul>
  </div>
</template>

<script>

import ClickOutside from '../../directives/click-outside';
import MenuButton from '../MenuButton.vue';

export default {
  name: 'OverflowMenu',
  components: { MenuButton },
  directives: {
    ClickOutside,
  },
  props: {
    onMenuOpened: { // use for logging / side effects
      type: Function,
      required: false,
    },
    ariaLabel: {
      type: String,
      required: false,
    },
    menuButtonColor: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      showMenu: false,
    };
  },
  methods: {
    toggleMenu() {
      const previousShowMenu = this.showMenu;
      if (!previousShowMenu) {
        this.showMenu = true;
        if (this.onMenuOpened) {
          this.onMenuOpened();
        }
      }
    },
    closeMenu() {
      this.showMenu = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './overflow-menu.styles';

</style>
